(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.BarksTermsEnforcement) {
    window.BarksTermsEnforcement = true

    const termsSelector = '.m-terms-conditons input[name="agree_terms"]'
    const checkoutSelector = 'button[name="checkout"][data-terms-action]'
    const scopeSelector = '.m-cart__checkout, .m-cart-drawer__footer'

    const findCheckbox = (element) => element.closest(scopeSelector)?.querySelector(termsSelector)

    const syncCheckbox = (checkbox) => {
      const button = checkbox.closest(scopeSelector)?.querySelector(checkoutSelector)
      if (!button) return

      button.disabled = !checkbox.checked
      button.setAttribute('aria-disabled', String(!checkbox.checked))
    }

    const saveAcceptance = async (checkbox) => {
      const button = checkbox.closest(scopeSelector)?.querySelector(checkoutSelector)
      if (!button) return

      const accepted = checkbox.checked
      const acceptedAt = accepted ? new Date().toISOString().replace(/\.\d{3}Z$/, 'Z') : ''
      const root = window.Shopify?.routes?.root || '/'

      checkbox.disabled = true
      button.disabled = true
      button.setAttribute('aria-disabled', 'true')

      try {
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              terms_accepted: accepted ? 'yes' : '',
              terms_accepted_at_utc: acceptedAt,
              terms_version: accepted ? checkbox.dataset.termsVersion : '',
            },
          }),
        })

        if (!response.ok) throw new Error(String(response.status))

        button.disabled = !accepted
        button.setAttribute('aria-disabled', String(!accepted))
      } catch {
        checkbox.checked = false
        button.disabled = true
        button.setAttribute('aria-disabled', 'true')
      } finally {
        checkbox.disabled = false
      }
    }

    const syncAll = () => document.querySelectorAll(termsSelector).forEach(syncCheckbox)

    document.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches(termsSelector)) {
        saveAcceptance(event.target)
      }
    })

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return

      const button = event.target.closest(checkoutSelector)
      if (!button) return

      const checkbox = findCheckbox(button)
      if (checkbox && !checkbox.checked) {
        event.preventDefault()
        event.stopImmediatePropagation()
        checkbox.focus()
        checkbox.reportValidity()
      }
    }, true)

    document.addEventListener('submit', (event) => {
      const submitter = event.submitter
      if (!(submitter instanceof HTMLButtonElement) || !submitter.matches(checkoutSelector)) return

      const checkbox = findCheckbox(submitter)
      if (checkbox && !checkbox.checked) {
        event.preventDefault()
        event.stopImmediatePropagation()
        checkbox.focus()
        checkbox.reportValidity()
      }
    }, true)

    window.addEventListener('pageshow', syncAll)
    syncAll()
  }
  } catch(e) { console.error(e); }
})();

})();
